import { MoneyMessage } from '../../../../../types/MoneyMessage';
import { Tooltip } from '../../../../cdl/Tooltip/Tooltip';
import { formatMoney } from '../../../../common/helpers/formatMoney.helper';
import { translate } from '../../../../common/helpers/translate.helper';
import { IconArrowsDiff } from '../../../../common/icons/cdl/ArrowsDiff';
import { Box } from '../../../../common/ui/Box';
import { theme } from '../../../../common/ui/theme';

interface PriceDifferenceProps {
    priceDifference: MoneyMessage;
}

export const PriceDifference = ({ priceDifference }: PriceDifferenceProps) => {
    const formattedDifference = formatMoney({
        value: priceDifference.value,
        currency: priceDifference.currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 4,
        signDisplay: 'never',
    });

    const tooltipLabel = translate('schedule.priceCompare.difference', {
        difference: formattedDifference,
    });

    return (
        <Tooltip label={tooltipLabel} showArrow>
            <Box
                width="24px"
                height="24px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{ cursor: 'default' }}
            >
                <IconArrowsDiff width={16} height={16} color={theme.colors.foreground.subtle} />
            </Box>
        </Tooltip>
    );
};
